<template>
    <div
        id="feedback-page"
        :style="{
            background: 'linear-gradient(0deg, var(--background-color-first), var(--background-color-second))',
            color: 'white',
        }"
    >
        <div v-if="loading" class="loading-bar">
            <div class="sps-spinner"></div>
        </div>
        <div v-else class="feedback-page-container">
            <div class="stars">
                <div class="stars-container">
                    <div class="avatar" v-if="participants.length">
                        <a-avatar :username="agentName()" :src="getAgentImage()" class="avatar">
                            {{ agentName().substr(0, 1).toUpperCase() }}
                        </a-avatar>
                    </div>
                    <div class="content">
                        <div class="visitor-title" style="color: var(--form-color-text)" v-if="participants.length">
                            <span class="representative-name">{{ participants[0].name }}</span>
                            <span class="representative-desc">{{ $t("visitorLanguage.rateTheMeting") }}</span>
                        </div>
                        <a-rate v-model="starPoint" />
                    </div>
                </div>
            </div>
            <div class="company-feedback">
                <div class="title">{{ $t("visitorLanguage.confirmExperience") }}</div>
                <div
                    class="item"
                    v-for="(item, index) in companyFBIcon"
                    :key="index"
                    @click="(item) => startClickHandler(item)"
                >
                    {{ item.icon }}
                </div>
            </div>
            <div class="info">
                <div class="title" style="color: var(--form-color-text)">
                    {{ $t("visitorLanguage.suggestion") }}
                </div>
                <div class="text-area" style="color: var(--form-color-text)">
                    <textarea
                        v-model="description"
                        @change="(e) => textAreaChangeHandler(e)"
                        :placeholder="$t('message.writePlaceHolder')"
                    />
                </div>
            </div>
            <div class="button-wrapper">
                <button class="btn btn-skip" @click="reconnect">
                    {{ $t("visitorLanguage.skip") }}
                </button>
                <button class="btn btn-send" @click="send" :disabled="!canSend">
                    {{ $t("visitorLanguage.send") }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { isChatRated, markChatRated, markRatingSkipped } from "../../utils/ratedChats";
import Button from "../../common/Button.vue";
import { sendSocketMessage } from "../../utils/socketStream";
import { log2 } from "../../utils/log2";
import _ from "lodash";
import { sessionId } from "../../utils/session";
import { getVisitorToken, VISITOR_TOKEN_SUPPORTED } from "../../utils/visitorToken";
import version from "../../utils/version";
import { getParticipantAvatar } from "../../utils/conversationHandler";

const log = log2("FeedBack");
export default {
    name: "FeedBack",
    components: { Button },
    props: {
        agent: {
            type: String,
        },
        participants: {
            type: Array,
        },
    },
    data() {
        return {
            starPoint: 0,
            companyFBIcon: [
                { icon: "😭", point: 1 },
                { icon: "😟", point: 2 },
                { icon: "🤨", point: 3 },
                { icon: "😁", point: 4 },
                { icon: "🤩", point: 5 },
            ],
            description: null,
            buttonOpacity: 0.5,
            loading: false,
        };
    },
    methods: {
        ...mapActions({
            resetConversation: "chat/resetConversation",
            toggleAfterActions: "app/toggleAfterActions",
            toggleRating: "app/toggleRating",
        }),
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
        }),
        send() {
            if (this.starPoint >= 1 || this.description) {
                log("send");
                let desc = this.description;

                sendSocketMessage("visitor rating", {
                    visitorId: this.visitorId,
                    conversationId: this.conversationId,
                    point: this.starPoint,
                    description: desc,
                    siteId: this.site._id,
                });

                markChatRated(this.conversationId);
                this.changePageIndex(6);

                this.buttonOpacity = 1;
            }
        },
        startClickHandler(chosen) {},
        textAreaChangeHandler(e) {
            this.description = e.target.value;
            e.focus();
        },
        changePageIndexByStorage() {
            if (isChatRated(this.conversationId)) {
                this.changePageIndex(6);
            }
        },
        agentName() {
            return this.participants.length ? this.participants[0].name : this.$t("message.representative");
        },
        // avatar adla ayni katilimcidan okunur
        getAgentImage() {
            return getParticipantAvatar(this.participants[0], this.settings);
        },
        connect() {
            sendSocketMessage("visitor connect", {
                visitorId: this.visitorId,
                visitorToken: getVisitorToken(),
                tokenSupported: VISITOR_TOKEN_SUPPORTED,
                conversationId: this.conversationId,
                siteId: this.site._id,
                sessionId,
                version,
            });
        },
        reconnect() {
            // "Atla" da bir karardir: isaretlenmezse konusma kapandiginda
            // degerlendirme ekrani tekrar aciliyordu.
            markChatRated(this.conversationId);
            markRatingSkipped();
            this.loading = true;
            // Ekrani hemen kapat: disconnect ile yeniden baglanma arasindaki
            // saniyede gelen olaylar degerlendirme ekranini geri aciyordu.
            // Sayfa da ayni anda donmeli, yoksa pageIndex 5'te kalip bos ekran cikiyor.
            this.changePageIndex(1);
            this.toggleRating(false);
            this.toggleAfterActions(false);
            this.disconnect();
            setTimeout(() => {
                this.resetConversation();
                this.connect();
                this.loading = false;
            }, 1000);
        },

        disconnect() {
            sendSocketMessage("visitor disconnect", {
                visitorId: this.visitorId,
                conversationId: this.conversationId,
                siteId: this.site._id,
            });
        },
        updateButtonOpacity() {
            if (this.starPoint >= 1 || this.description) {
                this.buttonOpacity = 1;
            } else {
                this.buttonOpacity = 0.5;
            }
        },
    },
    computed: {
        canSend() {
            return this.starPoint >= 1 || !!this.description;
        },
        ...mapState({
            chatAgents: (state) => state.chat.chatAgents,
            visitorId: (state) => state.chat.visitorId,
            conversationId: (state) => state.chat.lastConversationId,
            site: (state) => state.site.site,
            visitingPage: (state) => state.app.visitingPage,
            settings: (state) => state.setting.settings,
            backgroundColorFirst: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst",
                    "#fff"
                ),
            backgroundColorSecond: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorSecond",
                    "#fff"
                ),
        }),
    },

    mounted() {
        window.addEventListener("reconnect-event", this.reconnect);
        window.addEventListener("storage", this.changePageIndexByStorage);
    },
    watch: {
        starPoint: "updateButtonOpacity",
        description: "updateButtonOpacity",
        visitingPage() {
            if (this.visitingPage === 1) {
                this.reconnect();
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener("reconnect-event", this.reconnect);
        window.removeEventListener("storage", this.changePageIndexByStorage);
    },
};
</script>
<style lang="scss">
#feedback-page {
    .feedback-page-container {
        width: 100%;
        height: 100%;
        padding: 20px 15px;

        .stars {
            margin-bottom: 20px;

            .stars-container {
                display: flex;
                align-items: flex-start;

                .avatar {
                    width: 56px;
                    height: 56px;
                    min-width: 56px;
                    border-radius: var(--sps-radius-pill);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 18px;
                    font-weight: 600;
                    background-color: var(--agent-bubble-color) !important;
                    color: var(--button-color) !important;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .content {
                    margin-left: 10px;

                    .visitor-title {
                        display: block;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 21px;
                        color: var(--primary-text);
                        margin-bottom: 10px;
                    }

                    .ant-rate {
                        font-size: 25px !important;
                    }
                }
            }
        }

        .company-feedback {
            display: none; // backend yapıldığında açılacak :)
            .title {
                font-size: 28px;
                font-weight: 700;
                line-height: 33px;
                color: #38386e;
            }

            .item {
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #e9ecf2;
                border-radius: 50%;

                &:not(:last-child) {
                    margin-right: 10px;
                }

                &.click {
                    background: var(--background-color-first);
                }
            }
        }

        .info {
            width: 100%;
            position: relative;

            .title {
                margin-bottom: 10px;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: var(--primary-text);
                display: flex !important;
                justify-content: center !important;
            }

            // 205px'lik kutu ekranin yarisini kapliyordu
            .text-area {
                display: flex;
                // Marka renkli cerceve yerine dolgulu yuzey, odakta halka
                border: 1.5px solid transparent;
                background-color: #f3f4f6;
                border-radius: var(--sps-radius-md);
                height: 104px;
                overflow: hidden;
                padding: 12px 14px;
                transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;

                &:focus-within {
                    background-color: #fff;
                    border-color: var(--button-color);
                    box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);
                }

                textarea {
                    width: 100%;
                    height: 100%;
                    resize: none;
                    outline: none;
                    border: none;
                    font-family: inherit;
                    font-size: var(--sps-font-size, 14px);
                    line-height: 1.45;
                    color: var(--primary-text);
                    background-color: transparent;
                }
            }
        }

        .button-wrapper {
            display: flex;
            justify-content: center;
            gap: 10px;
            padding-top: 16px;
        }
    }

    // Gonder birincil, Atla ikincil: eskiden ikisi de ayni gorunuyor,
    // ustelik birincil solgun kaldigi icin zayif duruyordu.
    .btn {
        flex: 1;
        min-height: 46px;
        border-radius: var(--sps-radius-md);
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: transform 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
    }

    .btn-send {
        background: var(--button-color);
        border: 1px solid var(--button-color);
        // Etiket rengi buton zemininin parlakligindan turetiliyor (setupV2Theme).
        color: var(--button-text-color, #fff);
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);

        &:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(16, 24, 40, 0.16);
        }

        // Pasif hali solgun degil, sakin: saydam yazi okunmuyordu, duz ton.
        &:disabled {
            background: #edeef0;
            border-color: transparent;
            color: #5b626c;
            box-shadow: none;
            cursor: default;
        }
    }

    .btn-skip {
        background: #fff;
        border: 1px solid rgba(15, 23, 42, 0.14);
        color: var(--primary-text);

        &:hover {
            background: rgba(15, 23, 42, 0.04);
        }
    }

    // Yildizlar tema rengini alsin, solgun gri kalmasin
    .ant-rate {
        color: var(--button-color);
    }

    // Bos yildizlar da gorunur olsun
    .ant-rate-star-zero .anticon,
    .ant-rate-star-half .ant-rate-star-second .anticon {
        color: rgba(15, 23, 42, 0.18) !important;
    }
}
.loading-bar {
    margin: 0 auto;
    width: 150px !important;
    height: 150px !important;
    margin-top: 150px;
}
.representative-name {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
.representative-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}

// Koyu tema: sabit acik zeminler koyu yuzeye doner; acik tema hic degismez.
:root[data-color-scheme="dark"] #feedback-page {
    .info .text-area,
    .info .text-area:focus-within {
        background-color: var(--sps-surface-raised);
    }
    .btn-skip {
        background: var(--sps-surface-raised);
        border-color: var(--sps-border);
        &:hover {
            background: var(--sps-surface);
        }
    }
    .btn-send:disabled {
        background: var(--sps-surface-raised);
        color: var(--sps-muted);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/FeedBack.vue